let elementName = `nss-buybox-sticky-atc-variant`;
if (typeof customElements.get(elementName) === `undefined`) {
  class NSSBuyboxStickyATC extends HTMLElement {
    constructor() {
      super();

      this.debug = false;
    }

    init() {
      this.els = {
        qtyItems: this.querySelectorAll(`[nss-sticky-qty-item-count]`),
        frequencyItems: this.querySelectorAll(`[nss-frequency-update]`),
        atcBtn: this.querySelector(`[nss-add-to-cart-btn]`),
      };

      this.variantId = this.getAttribute(`nss-variant-id`);
    }

    connectedCallback() {
      if (this.debug) console.log(`[NSS][Buybox Sticky ATC] Connected.`);

      this.init();

      this.initStickyObservers();

      this.addEventListener(`click`, this.handleClick.bind(this));
      this.addEventListener(`buyboxUpdate`, this.handleUpdate.bind(this));
      // this.addEventListener(`buyboxReload`, this.reloadHandler.bind(this));
    }

    async fetchSection() {
      const parser = new DOMParser();
      const sectionID = this.getAttribute(`nss-parent-section-id`);
      const markup = await (await fetch(`?section_id=${sectionID}`)).text();
      const dom = parser.parseFromString(markup, "text/html");
      return dom;
    }

    async reloadHandler() {
      const dom = await this.fetchSection();

      const selectorParent = `nss-buybox-sticky-atc-variant[nss-variant-id="${this.variantId}"]`;
      const selectorChild = `.nss-buybox-sticky-atc__inner`;
      const selector = `${selectorParent} ${selectorChild}`;
      const newAtc = dom.querySelector(selector);
      const thisAtc = this.querySelector(selectorChild);
      thisAtc.replaceWith(newAtc);

      this.init();
    }

    handleClick(e) {
      if (this.debug) console.log(`[NSS][Buybox Sticky ATC] Click - e.target:`, e.target);

      if (e.target.hasAttribute(`nss-add-to-cart-btn`)) {
        // The form lives in the nss-buybox-atc block (or subscription CTA) — resolve
        // it within THIS sticky's own section by variant id, so a second same-product
        // buybox section's form isn't targeted by mistake.
        const scope = this.closest(`[id^="shopify-section"]`) || document;
        const formEl = scope.querySelector(
          `[nss-variant-id="${this.variantId}"] .shopify-product-form`
        );
        if (formEl) formEl.requestSubmit();
      }
    }

    initStickyObservers() {
      // Show the sticky bar only once the related ATC has scrolled off the TOP
      // of the viewport (i.e. the user scrolled PAST it) — NOT while it's still
      // below the fold. Hide again when the footer comes into view.
      // (The ATC block's .nss-buybox__atc is the control we track;
      // scoped to this sticky's own section so a second buybox section's ATC
      // isn't watched.)
      const scope = this.closest(`[id^="shopify-section"]`) || document;
      const controlsEls = scope.querySelectorAll(`.nss-buybox__atc`);
      const footerEl = document.querySelector(`nss-footer`);

      this.atcAboveTop = false;
      this.footerInView = false;

      const update = () => {
        if (this.atcAboveTop && !this.footerInView) {
          this.showStickyBar();
        } else {
          this.hideStickyBar();
        }
      };

      // threshold 0 → fires on the exact enter/leave crossing; the bounding rect
      // then distinguishes "off the top" (bottom at/above the viewport top) from
      // "off the bottom" (still below the fold). Hidden variant ATCs are
      // display:none (zero-size rect) — skip them so only the active one counts.
      const controlsObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.boundingClientRect.height === 0) return;
            this.atcAboveTop = entry.boundingClientRect.bottom <= 0;
          });
          update();
        },
        { root: null, threshold: 0 }
      );
      controlsEls.forEach((controlsEl) => controlsObserver.observe(controlsEl));

      if (footerEl) {
        const footerObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.footerInView = entry.isIntersecting;
            });
            update();
          },
          { root: null, threshold: 0.1 }
        );
        footerObserver.observe(footerEl);
      }
    }

    showStickyBar() {
      this.classList.add(`nss-open`);
      // this.els.docEl.style.setProperty(`--nss-sticky-atc-pos`, `100px`);
    }

    hideStickyBar() {
      this.classList.remove(`nss-open`);
      // this.els.docEl.style.setProperty(`--nss-sticky-atc-pos`, `0px`);
    }

    handleUpdate(e) {
      const oldId = e.detail.oldId;
      const newId = e.detail.newId;

      // Scope to this sticky's own buybox so an unrelated product's switch
      // elsewhere on the page can't blank it (document-wide buyboxUpdate bus).
      const scope =
        this.closest(`nss-buybox`) || this.closest(`[id^="shopify-section"]`) || document;
      if (!scope.querySelector(`[nss-buybox-update][nss-variant-id="${newId}"]`)) {
        return;
      }

      if (newId === this.variantId) {
        if (this.debug) console.log(`[NSS][Buybox Sticky ATC] handleUpdate e.detail:`, e.detail);
        this.classList.add(`nss-active`);
      } else {
        this.classList.remove(`nss-active`);
      }

      if (newId === this.variantId && oldId === newId) {
        // Update quantity
        if (this.debug)
          console.log(
            `[NSS][Buybox Sticky ATC] handleUpdate e.detail.quantity:`,
            e.detail.quantity
          );
        if (e.detail.quantity !== null) {
          this.els.qtyItems.forEach((qtyItemEl) => {
            const count = qtyItemEl.getAttribute(`nss-sticky-qty-item-count`);
            const total = count * parseInt(e.detail.quantity);
            qtyItemEl.innerHTML = total;
          });
        }

        // Update selling plan
        if (this.debug)
          console.log(
            `[NSS][Buybox Sticky ATC] handleUpdate e.detail.sellingPlanId:`,
            e.detail.sellingPlanId
          );
        if (e.detail.sellingPlanId !== null) {
          this.els.frequencyItems.forEach((frequencyItemEl) => {
            frequencyItemEl.classList.remove(`nss-active`);
          });
          const updateFrequencyEls = this.querySelectorAll(
            `[nss-frequency-update="${e.detail.sellingPlanId}"]`
          );
          updateFrequencyEls.forEach((updateFrequencyEl) => {
            updateFrequencyEl.classList.add(`nss-active`);
          });
        }

        // Update ATC text
        if (this.els.atcBtn) {
          const atcSpanEl = this.els.atcBtn.querySelector(`span`);
          // let atcText = "ADD TO CART";
          // if (e.detail.sellingPlanId !== "") {
          //   atcText = this.els.atcBtn.getAttribute(`nss-atc-sub-text`);
          // } else {
          //   atcText = this.els.atcBtn.getAttribute(`nss-atc-otp-text`);
          // }
          // atcSpanEl.innerHTML = atcText;
        }
      }
    }
  }

  customElements.define(elementName, NSSBuyboxStickyATC);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}
